import { useQuery } from "@tanstack/react-query";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { Callout } from "@/components/ui/callout";
import { useAuth } from "@/features/auth/store";
import { orderCalls } from "@/features/sales-dispatch/api";
import { errMsg } from "@/features/sales-dispatch/components/common";
import { OrderPage } from "@/features/sales-dispatch/components/order-page";

export const Route = createFileRoute("/_app/orders/$id")({
  beforeLoad: () => {
    if (!useAuth.getState().can("orders.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  const order = useQuery({
    queryKey: ["orders", "detail", Number(id)],
    queryFn: () => orderCalls.get(Number(id)),
  });
  if (order.isPending) return <FormPageSkeleton />;
  if (order.isError)
    return (
      <Callout tone="danger" title="Could not open this order">
        {errMsg(order.error)}
      </Callout>
    );
  return (
    <OrderPage
      key={`${order.data.id}-${order.data.status}-${order.data.version}`}
      order={order.data}
      orderType={order.data.orderType}
      facilityId={order.data.facilityId}
    />
  );
}
